import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { shallowEqual } from 'recompose'

import * as actions from 'modules/search/actions'
import { QueryTypes } from 'modules/search/types'
import SearchFormMin from 'modules/search/components/SearchFormMin'

import withLocalized from 'modules/localization/withLocalized'

import { API_SEARCH_ROOT } from 'api/constants'

class Search extends PureComponent {
  state = {
    isValid: false,
    queryString: '',
    suggestions: [],
  }

  componentWillMount() {
    this.updateSearchState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if(!shallowEqual(nextProps.search, this.props.search)){
      this.updateSearchState(nextProps)
    }
  }
  
  updateSearchState = (props) => {
    const {
      search: {
        query: {
          text = '',
        } = {}
      } = {}
    } = props
    
    this.setState({
      queryString: text,
      isValid: !!text.length
    })
  }

  getSuggestions = string => {
    fetch(`${API_SEARCH_ROOT}/suggest/${string}`)
      .then(res => res.json())
      .then(res => this.setState({
        suggestions: res
      }))
      .catch(err => {})
  }

  onSuggestionClick = (text) => {
    this.setState({
      queryString: text,
      isValid: !!text.length,
      suggestions: [],
    }, () => this.validate(true))
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.handleSubmitClick()
  }

  handleSubmitClick = () => {
    const {
      queryString = ''
    } = this.state
    
    if(!queryString.length){ // don't submit empty query
      return
    }

    const query = {
      //type: `${QueryTypes.COURSE},${QueryTypes.SERVICE}`,
      type: `${QueryTypes.SERVICE}`,
      text: encodeURIComponent(queryString),
    }
    
    const queryParams = Object.keys(query).filter(param => !!query[param]).map(param => `${param}=${query[param]}`).join("&")

    this.props.history.push(`/search?${queryParams}`)
  }
  
  onTextChange = event => {
    const {
      target: {
        value = ''
      } = {}
    } = event
    this.setState({
      queryString: value
    }, () => {
      this.validate()
      if(value.length > 2){
        this.getSuggestions(value)
      }
    })
  }

  validate = (submit = false) => {
    const isValid = !!this.state.queryString
    this.setState({
      isValid
    }, () => {
      if(submit){
        this.handleSubmitClick()
      }
    })
  }

  render() {
    const {
      isValid,
      queryString,
      suggestions,
    } = this.state

    const {
      onCancelClick,
      label,
      localized,
    } = this.props

    const submitEnabled = isValid
    
    return (
      <SearchFormMin
        value={queryString}
        label={label}
        onCancel={onCancelClick}
        submitEnabled={submitEnabled}
        onSubmit={this.handleSubmit}
        onSubmitClick={this.handleSubmitClick}
        onFocus={this.onFocus}
        onTextChange={this.onTextChange}
        placeholder={localized('search.form.placeholder_location_input')}
        buttonText={localized('search.form.label_search')}
        suggestions={suggestions}
        onSuggestionClick={this.onSuggestionClick}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { search } = state

  return {
    search,
    ...ownProps,
  }
}

const ConnectedSearch = withLocalized(withRouter(connect(mapStateToProps, {...actions})(Search)))

export default ConnectedSearch




// WEBPACK FOOTER //
// ./src/modules/search/components/Search.js